export const AccordionDetailsPanel = {
  baseStyle: {
    padding: 0,
  },
};

export const AccordionDetailsItem = {
  baseStyle: {
    border: 0,
  },
};

export const AccordionDetailsButton = {
  parts: ['Button', 'Heading', 'DescriptionHeading', 'Details', 'Icon'],
  baseStyle: {
    Button: {
      padding: '40px 64px',
      borderTop: 0,
      borderBottom: 'solid 1px',
      borderBottomColor: 'brand.lightgrey',
    },
    Heading: {
      lineHeight: '24px',
      fontSize: '24px',
      fontWeight: 600,
      textAlign: 'left',
    },
    DescriptionHeading: {
      paddingBottom: '4px',
      lineHeight: '24px',
      fontSize: '24px',
      fontWeight: 600,
      textAlign: 'left',
    },
    Details: {
      fontSize: '12px',
      textTransform: 'uppercase',
      fontWeight: 600,
      textAlign: 'left',
      letterSpacing: '2px',
    },
    Icon: {
      width: '55px',
      height: '55px',
      marginRight: '12px',
    },
  },
};
